/**
 * QEE assistant avatar.
 * Developers: Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 */
import React, {useEffect, useState} from 'react';
import {Avatar, Box} from '@mui/material';
import QeeTooltip from '../../../../qeeTooltip';
import {ChatImageViewer} from './ChatImageViewer';
import synapcusIcon from '../../../../../assets/chat/synapcus-s.png';
import leylaHappy from '../../../../../assets/chat/leyla-boss/happy.png';
import leylaThoughtful from '../../../../../assets/chat/leyla-boss/thoughtful.png';
import leylaConcerned from '../../../../../assets/chat/leyla-boss/concerned.png';
import leylaDecisive from '../../../../../assets/chat/leyla-boss/decisive.jpg';
import leylaPrj from '../../../../../assets/chat/leyla-boss/prj-architect.jpg';
import leylaHr from '../../../../../assets/chat/leyla-boss/hr-manager.jpg';
import leylaCrm from '../../../../../assets/chat/leyla-boss/crm-success.jpg';
import leylaAddress from '../../../../../assets/chat/leyla-boss/address-friendly.jpg';

const LEYLA_ASSETS = {
	happy: leylaHappy,
	thoughtful: leylaThoughtful,
	concerned: leylaConcerned,
	decisive: leylaDecisive,
	prj: leylaPrj,
	hr: leylaHr,
	crm: leylaCrm,
	address: leylaAddress
};

export function ChatAssistantAvatar({assetKey = 'synapcus', tooltip = 'Synapcus', viewerLabels = {}, size = 40}) {
	const requestedAsset = LEYLA_ASSETS[assetKey] || synapcusIcon;
	const [assetFailed, setAssetFailed] = useState(false);
	const [viewerOpen, setViewerOpen] = useState(false);

	useEffect(() => setAssetFailed(false), [requestedAsset]);

	const avatar = (
		<Avatar
			alt={tooltip}
			src={assetFailed ? synapcusIcon : requestedAsset}
			imgProps={{onError: () => setAssetFailed(true)}}
				sx={{
				width: size,
				height: size,
				bgcolor: assetKey === 'synapcus' || assetFailed ? '#4a4a4a' : '#faf9f6',
				border: assetKey === 'synapcus' || assetFailed ? 'none' : '1px solid rgba(0, 82, 70, 0.18)',
				'& img': {objectFit: 'cover'}
			}}
		>
			S
		</Avatar>
	);
	const displayedAsset = assetFailed ? synapcusIcon : requestedAsset;
	return (
		<>
			<QeeTooltip title={tooltip}>
				<Box
					component="button"
					type="button"
					onClick={() => setViewerOpen(true)}
					aria-label={tooltip}
					sx={{display: 'block', p: 0, border: 0, borderRadius: '50%', bgcolor: 'transparent', cursor: 'zoom-in', lineHeight: 0}}
				>
					{avatar}
				</Box>
			</QeeTooltip>
			<ChatImageViewer
				image={viewerOpen ? {url: displayedAsset, title: tooltip, alt: tooltip} : null}
				onClose={() => setViewerOpen(false)}
				labels={{closeImage: viewerLabels.closeImage || 'Close', imageSource: viewerLabels.imageSource || ''}}
			/>
		</>
	);
}
